import React from 'react';

export default function About() {
  return (
    <section id="about" className="relative py-20 min-h-screen flex items-center">
      {/* Background Image with Parallax-like effect */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed z-0"
        style={{ 
          backgroundImage: 'url("https://static.lumi.new/87/87dabfc34549fd1372699bd20e9469e4.png")', // DJI Drone Landscape
        }}
      />
      <div className="absolute inset-0 bg-black/80 z-10" /> {/* Dark overlay for readability */}

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">Quem Somos</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-1 gap-12 text-lg leading-relaxed text-gray-200 text-justify">
          <div className="bg-black/40 backdrop-blur-sm p-8 rounded-2xl border border-white/10 shadow-2xl">
            <p className="mb-6">
              A <span className="font-bold text-blue-400">Aeromaps Bahia</span> surgiu de forma despretensiosa, quando, eu, 
              <span className="font-bold text-white"> Marcio Belas</span>, num momento de grande transição da minha vida familiar, 
              pois tínhamos acabado de nos mudar para outra cidade, de uma mudança profissional também, onde saí de uma grande empresa 
              após 18 anos de muito aprendizado e dedicação e preste a encabeçar em outro segmento do qual, mesmo com grande bagagem 
              organizacional, seria um desafio enorme mudar completamente a área de negócio.
            </p>
            
            <p className="mb-6">
              Foi neste intervalo que, juntamente com minha esposa, <span className="font-bold text-white">Lais Melo</span>, 
              tivemos nosso primeiro contato com o mundo RPAS, primeiramente sem vínculo profissional, mas que em pouco tempo já pude 
              levar todo meu know-how tecnológico para agregar e otimizar serviços direcionados a parte de segurança patrimonial, 
              vistorias, capacitações e demais áreas onde víamos que poderíamos entregar aos clientes qualidade, segurança e redução de custo.
            </p>

            <p className="mb-6">
              Então esse intervalo que durou alguns meses chegou ao fim, iniciei minha trajetória em uma Multinacional mas o “drone” 
              não saiu mais de mim. Devido a isso adquirimos nossa primeira aeronave da DJI e através dela buscamos nos capacitar e 
              dar continuidade ao negócio que outrora pensamos e aqui estamos nós.
            </p>

            <div className="mt-10 p-6 bg-blue-900/20 rounded-xl border-l-4 border-blue-500">
              <h3 className="text-xl font-bold text-white mb-4">Agradecimentos Especiais</h3>
              <p className="mb-2">Aos nossos 03 lindos filhos e toda nossa abençoada família que nos motivam diariamente</p>
              <ul className="list-disc pl-5 space-y-2 mb-4">
                <li><span className="font-semibold text-blue-300">Frederico Miranda:</span> Referência RPAS, parceiro, professor e visionário.</li>
                <li><span className="font-semibold text-blue-300">Paulo Sacramento:</span> Exímio profissional de gestão organizacional e segurança.</li>
                <li><span className="font-semibold text-blue-300">Erick Santos:</span> Empreendedor nato e visionário no segmento RPAS.</li>
              </ul>
              <p className="mb-2">
                Ao <span className="font-bold text-blue-300">(GRAER) Grupamento Aéreo da Polícia Militar do Estado da Bahia</span> – 
                que me permitiu formar no CORPAS 2025.1, em uma capacitação de 120h de vasto conhecimento para me certificar oficialmente como Piloto RPAS.
              </p>
            </div>

            <p className="mt-8 text-center font-medium italic text-xl text-blue-200">
              "Desejamos a todos voos cada vez mais altos!!"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
